// The crime types used by the police (data.police.uk), alphabetically. 'total' is every type.
// In its own module so the Redux slice can default to every type without importing BaseLayer.
export const CRIME_TYPES = ['Anti-social behaviour', 'Bicycle theft', 'Burglary', 'Criminal damage and arson', 'Drugs',
    'Other crime', 'Other theft', 'Possession of weapons', 'Public order', 'Robbery', 'Shoplifting',
    'Theft from the person', 'Vehicle crime', 'Violence and sexual offences'];

export const crimeTypeLabel = (crimeType) => crimeType==='total' ? 'All crimes' : crimeType;
